module.exports = __webpack_public_path__ + "img/horizontal_3_3_3.45742b92.png";